// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 770) return "static/chunks/770-1cef202b5868284c.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"70dd5c3b9cca7a93","298":"3c17f9a45cf5b456","340":"2d3cfa5c12c30bca","367":"20c4e81b75950115","639":"662b2e7c337118a6","748":"a836fa93cca43992"}[chunkId] + ".js";
};